import React from 'react';

export interface ItemsByTrigger {
  [key: string]: {
    triggerItemIds: string[];
    taskItemId?: string;
    formItemId?: string;
    taskFieldId?: string;
    optionType?: string;
  };
}

export interface ItemsByTriggerOption {
  [key: string]: string | undefined;
}

export interface BuilderItems {
  byTrigger: ItemsByTrigger;
  byTriggerOption: ItemsByTriggerOption;
  byId: { [key: string]: any };
  allIds: string[];
}

export interface BuilderContextValue {
  items: BuilderItems;
  draggingId: string;
  renderItem: (itemId: string, index: number) => React.ReactNode;
  itemLabel: string;
}

export const BuilderContext = React.createContext<BuilderContextValue | null>(null);
